import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { isDesktopMediaQuery } from '../../constants/constants';
import { AppDispatch, RootState } from '../../redux-stores/store';
import { POSTAPIError } from '../../types';
import { fetchCollaborations } from '../../redux-stores/slices/collaborationSlice';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import ApplicationCard from './ApplicationCard';

const AppliedApplications = () => {
    const dispatch: AppDispatch = useDispatch();

    const { items: applications, loading, page, has_more } = useSelector(
        (state: RootState) => state.collaborations
    );

    const [pageLoading, setPageLoading] = useState(false);

    const nextPage = () => {
        if (has_more) {
            const nextPageNumber = page + 1;
            fetchCollaborationData(nextPageNumber)
        }

    }

    const fetchCollaborationData = useCallback(async (pageNumber: number) => {
        try {
            setPageLoading(true);
            await dispatch(fetchCollaborations({ page: pageNumber }));
        } catch (error) {
            console.log('err', error);
        } finally {
            setPageLoading(false);
        }
    }, [dispatch])

    useEffect(() => {
        fetchCollaborationData(1);
    }, [fetchCollaborationData])
    return (
        <div>
            <InfiniteScroll
                dataLength={applications.length}
                next={nextPage}
                hasMore={has_more}
                loader={<></>}
                className='d-flex flex-column gap-3 p-3'
            >
                {applications.map((application, index) => (
                    <ApplicationCard applied={true} key={index} application={application} />
                ))}
                {
                    pageLoading && <Skeleton height={170} width={'100%'} borderRadius={'1rem'} count={5} className='mb-3' />
                }
                {
                    !pageLoading && applications.length === 0 && (
                        <div className='d-flex py-5 my-5 flex-column align-items-center justify-content-center h-100'>
                            <span className='fs-16 text-muted fw-400'>No applications yet!</span>
                        </div>
                    )
                }
            </InfiniteScroll>
        </div>
    )
}

export default AppliedApplications